import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articles } from "@/mocks/articles";
import { hotComments } from "@/mocks/comments";

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === id);

  const [commentIdx, setCommentIdx] = useState(0);
  const articleComments = hotComments.filter((c) => c.articleId === id);
  const currentComment = articleComments[commentIdx] || articleComments[0];

  useEffect(() => {
    if (article) {
      document.title = `${article.title} - 黑料吃瓜网`;
    }
  }, [article]);

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground-900 mb-2">
            文章不存在
          </h1>
          <Link
            to="/"
            className="text-primary-500 hover:underline text-sm"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const nextComment = () => {
    setCommentIdx((i) => (i + 1) % articleComments.length);
  };
  const prevComment = () => {
    setCommentIdx((i) => (i - 1 + articleComments.length) % articleComments.length);
  };

  const related = articles.filter((a) => a.category === article.category && a.id !== article.id).slice(0, 3);

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    author: {
      "@type": "Person",
      name: article.author,
    },
    publisher: {
      "@type": "Organization",
      name: "黑料吃瓜网",
      logo: "http://obyqdiy.cn/logo.png",
    },
    datePublished: article.publishDate,
    articleSection: article.category,
    keywords: article.tags.join(","),
    url: `http://obyqdiy.cn/article/${article.id}`,
  };

  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "http://obyqdiy.cn/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: article.category,
        item: `http://obyqdiy.cn/category/${article.categorySlug}`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: article.title,
        item: `http://obyqdiy.cn/article/${article.id}`,
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbList)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Article Hero */}
          <section className="relative min-h-[480px] md:min-h-[560px] flex items-end pb-10 md:pb-16 overflow-hidden">
            <div className="absolute inset-0">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/80" />
            </div>

            <div className="relative z-10 w-full px-4 md:px-8">
              <div className="max-w-7xl mx-auto">
                {/* Breadcrumb */}
                <nav aria-label="面包屑导航" className="mb-4">
                  <ol className="flex items-center gap-2 text-xs text-white/70 flex-wrap">
                    <li>
                      <Link to="/" className="hover:text-white transition-colors">
                        首页
                      </Link>
                    </li>
                    <li><i className="ri-arrow-right-s-line" /></li>
                    <li>
                      <Link
                        to={`/category/${article.categorySlug}`}
                        className="hover:text-white transition-colors"
                      >
                        {article.category}
                      </Link>
                    </li>
                    <li><i className="ri-arrow-right-s-line" /></li>
                    <li className="text-white max-w-[200px] truncate">{article.title}</li>
                  </ol>
                </nav>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                  <div>
                        <div className="flex items-center gap-3 mb-4">
                          <div className="flex -space-x-2">
                            <img
                              src="https://readdy.ai/api/search-image?query=Anonymous%20person%20avatar%20portrait%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=60&height=60&seq=insider-1&orientation=squarish"
                              alt="圈内人"
                              className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                            <img
                              src="https://readdy.ai/api/search-image?query=Shadowy%20figure%20profile%20avatar%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=60&height=60&seq=insider-2&orientation=squarish"
                              alt="圈内人"
                              className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                            <img
                              src="https://readdy.ai/api/search-image?query=Silhouette%20avatar%20portrait%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20editorial%20style&width=60&height=60&seq=insider-3&orientation=squarish"
                              alt="圈内人"
                              className="w-8 h-8 rounded-full border-2 border-white object-cover"
                            />
                          </div>
                          <span className="text-white/80 text-sm">圈内人爆料确认</span>
                        </div>

                    <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-white leading-tight">
                      {article.title}
                    </h1>

                    <div className="mt-4 flex items-center gap-3">
                      <button
                        type="button"
                        className="inline-flex items-center gap-2 bg-white text-foreground-900 px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors"
                        onClick={() => {
                          if (navigator.share) {
                            navigator.share({
                              title: article.title,
                              text: article.excerpt,
                              url: window.location.href,
                            });
                          } else {
                            navigator.clipboard.writeText(window.location.href);
                          }
                        }}
                      >
                        <i className="ri-share-line" />
                        分享爆料
                      </button>
                      <span className="text-white/60 text-xs">
                        {article.publishDate} · {article.views.toLocaleString()} 阅读
                      </span>
                    </div>
                  </div>

                  <p className="hidden md:block text-white/80 text-sm leading-relaxed text-right max-w-md ml-auto">
                    {article.excerpt}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Content */}
          <div className="px-4 md:px-8 max-w-7xl mx-auto py-10 md:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
              {/* Main Content */}
              <article className="lg:col-span-2">
                <div className="flex items-center gap-3 mb-6">
                  <img
                    src={article.authorAvatar}
                    alt={article.author}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {article.author}
                    </p>
                    <p className="text-xs text-foreground-400">
                      {article.publishDate}
                    </p>
                  </div>
                  <div className="ml-auto flex items-center gap-2">
                    {article.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-[10px] text-secondary-600 font-medium bg-secondary-100 px-2 py-0.5 rounded"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="prose prose-sm max-w-none text-foreground-800 leading-relaxed">
                  <p className="text-base md:text-lg mb-6 font-medium text-foreground-900">
                    {article.excerpt}
                  </p>
                  <p className="mb-4">{article.content}</p>
                  <p className="mb-4">
                    随着事件持续发酵，更多知情者开始站出来发声。据某娱乐业内人士透露，此次事件恐怕只是冰山一角，后续可能还有更大猛料即将曝光。该人士表示："圈子里都知道的事情，只是没有实锤。这次有人把录音放出来，说明背后的博弈已经很激烈了。"
                  </p>
                  <p className="mb-4">
                    目前，相关话题已在多个社交平台登上热搜榜首，讨论量突破千万。大量网友纷纷留言表示"吃瓜吃撑了""娱乐圈水太深""粉丝真金白银养出来的明星就这人品"等。
                  </p>
                  <p>
                    本站将持续跟进此事后续发展，第一时间为瓜友们带来最新进展。敬请关注黑料吃瓜网，吃瓜第一线随时为您开启。
                  </p>
                </div>

                {/* Heat bar */}
                <div className="mt-8 p-4 bg-background-100 rounded-lg flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <i className="ri-fire-fill text-primary-500" />
                    <span className="text-sm font-semibold text-foreground-900">
                      当前热度
                    </span>
                  </div>
                  <span className="text-2xl font-bold text-primary-600">
                    {article.heat.toLocaleString()}
                  </span>
                </div>
              </article>

              {/* Sidebar */}
              <aside className="space-y-6">
                <div className="bg-background-100 rounded-xl p-5">
                  <h3 className="text-sm font-bold text-foreground-900 mb-4">
                    相关追踪
                  </h3>
                  {related.length > 0 ? (
                    <div className="space-y-4">
                      {related.map((ra) => (
                        <Link
                          key={ra.id}
                          to={`/article/${ra.id}`}
                          className="flex items-start gap-3 group"
                        >
                          <div className="w-16 h-16 rounded-lg overflow-hidden shrink-0">
                            <img
                              src={ra.image}
                              alt={ra.title}
                              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform"
                            />
                          </div>
                          <div>
                            <h4 className="text-xs font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                              {ra.title}
                            </h4>
                            <p className="text-[10px] text-foreground-400 mt-1">
                              {ra.heat.toLocaleString()} 热度
                            </p>
                          </div>
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <p className="text-xs text-foreground-400">暂无相关文章</p>
                  )}
                </div>

                <div className="bg-foreground-800 rounded-xl p-5 text-white">
                  <h3 className="text-sm font-bold mb-3">订阅该分类</h3>
                  <p className="text-xs text-white/60 mb-4">
                    第一时间获取{article.category}分类的最新爆料
                  </p>
                  <button
                    type="button"
                    className="w-full py-2.5 bg-white text-foreground-900 text-xs font-semibold rounded-full hover:bg-background-100 transition-colors"
                  >
                    立即订阅
                  </button>
                </div>
              </aside>
            </div>
          </div>

          {/* Hot Comments */}
          {articleComments.length > 0 && (
            <section className="bg-background-100 py-12 md:py-16">
              <div className="px-4 md:px-8 max-w-3xl mx-auto">
                <div className="text-center mb-8">
                  <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                    （精选热评）
                  </h2>
                </div>

                <div className="relative">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="px-3 py-1 bg-foreground-800 text-white text-xs font-semibold rounded-full flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500" />
                      {currentComment.rating} 辣度
                    </span>
                  </div>

                  <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-heading mb-6">
                    "{currentComment.content}"
                  </blockquote>

                  <div className="flex items-center gap-3">
                    <img
                      src={currentComment.userAvatar}
                      alt={currentComment.userName}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">
                        {currentComment.userName}
                      </p>
                      <p className="text-xs text-foreground-400">
                        {currentComment.location} · {currentComment.time}
                      </p>
                    </div>
                  </div>

                  {/* Navigation */}
                  <div className="flex items-center gap-2 mt-6 justify-end">
                    <button
                      type="button"
                      onClick={prevComment}
                      className="w-9 h-9 border border-foreground-200 rounded flex items-center justify-center hover:bg-background-100 transition-colors"
                      aria-label="上一条热评"
                    >
                      <i className="ri-arrow-left-line text-sm" />
                    </button>
                    <button
                      type="button"
                      onClick={nextComment}
                      className="w-9 h-9 bg-foreground-900 text-white rounded flex items-center justify-center hover:bg-foreground-700 transition-colors"
                      aria-label="下一条热评"
                    >
                      <i className="ri-arrow-right-line text-sm" />
                    </button>
                  </div>
                </div>
              </div>

              {/* FAQPage JSON-LD mapped from comments */}
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "FAQPage",
                  mainEntity: articleComments.map((c) => ({
                    "@type": "Question",
                    name: `网友${c.userName}的热评`,
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: c.content,
                    },
                  })),
                })}
              </script>
            </section>
          )}

          {/* Team Endorsement */}
          <section className="bg-accent-50 py-12 md:py-16 px-4 md:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="mb-8">
                <span className="inline-block px-4 py-1.5 bg-white text-accent-700 text-xs font-semibold rounded-full mb-4">
                  权威信源
                </span>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                  十年娱记
                  <br />
                  一线资源
                </h2>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
                {["一线跟踪", "独家专访", "深度撰稿", "全网首发"].map((item) => (
                  <div
                    key={item}
                    className="text-center p-4 bg-white rounded-lg"
                  >
                    <p className="text-sm font-semibold text-foreground-900">
                      {item}
                    </p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                {[
                  { num: "12,800+", label: "爆料文章" },
                  { num: "3,500+", label: "独家爆料" },
                  { num: "1.2亿", label: "总阅读量" },
                  { num: "2,800", label: "追踪天数" },
                ].map((stat) => (
                  <div key={stat.label}>
                    <p className="text-2xl md:text-3xl font-bold text-accent-700">
                      {stat.num}
                    </p>
                    <p className="text-xs text-foreground-500 mt-1">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}